<template>
    <popup :opened="dataToShow" @close="close">
        <!-- BEGIN Content modal add Atout -->
        <div v-if="dataToShow">
            <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
                <h3 class="mb-10">Ajouter une valeur personnelle manuellement</h3>
                <h6 class="text-indigo-600">Saissisez le nom de la valeur à ajouter.</h6>
                <h6 class="text-indigo-600 mb-8">Vous pouvez en ajouter plusieurs à la fois en les séparant d’une virgule.</h6>
                <div class="flex justify-center">
                    <input-text
                        :error="true"
                        placeholder="Exemple : “Curiosité“"
                        :value="atoutName"
                        class="lg:w-1/2"
                        libelle="Valeur personnelle"
                        name="atoutName"
                        @input="(newValue) => {atoutName = newValue}"
                        :maxlength="limit"
                    />
                </div>

                <div class="flex justify-center mt-15">
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        libelle="AJOUTER"
                        type-shadow="shadow-pink"
                        @clickAction="addAtout()"
                    />
                </div>

            </div>
        </div>
    </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from  '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';

export default {
  name:'PopupNewAtout',

  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
    limit:{
      type:Number,
      required:false,
      default: null
    }
  },

  data(){
    return {
      atoutName: '',
    };
  },

  methods:{
    close(){
      this.$emit('close');
      this.atoutName = '';
    },

    addAtout(){
      this.$emit('addAtout', this.atoutName);
      this.close(false);
      this.atoutName = '';
    },
  },
  watch:{
    //
  }
};
</script>
